import { memo } from 'react';
import { IBulletInfoCardProps } from './BulletInfoCard.types';
import styles from './styles.module.scss';

export const BulletInfoCard = memo<IBulletInfoCardProps>(({ Svg, title, content }) => (
  <div className={styles.container}>
    <Svg />
    <div className={styles.bulletPointContainer}>
      <span className={styles.title}>{title}</span>

      <span className={styles.content}>{content}</span>
    </div>
  </div>
));

BulletInfoCard.displayName = 'BulletInfoCard';

export default BulletInfoCard;
